const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web;

export default {
    methods: {
        /**
         * メンテ中ならメンテ専用ページを表示
         */
        async maintenanceCheck() {
            const cmdNo = pb.KumaMasterSettingReq.CommandNo.COMMAND_NO;
            const message = pb.KumaMasterSettingReq.create({
                id: this.id,
            });
            const encoded = pb.KumaMasterSettingReq.encode(message).finish()

            this.post(cmdNo, encoded)
                .then(decoded => {
                    if (decoded.status === pb.KumaMasterSettingResp.Status.SUCCESS && decoded.isMaintenanceNow) {
                        this.$_error('Error', { title: "プリクラONは現在メンテナンス中です", statusCode: 300 })
                    }
                })
        },
    }
}